export default "__VITE_ASSET__DZliOZY5__"